import type { MutableState } from 'src/replicant/State';
import { type TutorialStep } from './tutorial.ruleset';

export function setTutorialStepComplete(
  state: MutableState,
  step: TutorialStep,
): void {
  const { tutorial } = state;
  switch (step) {
    case 'basicGameplay':
    case 'careForPets':
    case 'chatWithPets':
    case 'friendReferral':
    case 'profile':
    case 'match3':
    case 'visitFriend':
      tutorial[`${step}Shown`] = true;
      break;

    case 'puzzleCoinsBasic':
      tutorial.basicGameplayShown = true;
      tutorial.chatWithPetsShown = true;
      break;

    case 'puzzleCoinsCare':
      tutorial.careForPetsShown = true;
      break;

    default:
      tutorial[step] = true;
      break;
  }
}
